import { render, staticRenderFns } from "./CompletedMissions.vue?vue&type=template&id=6629b3b2&"
import script from "./CompletedMissions.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CompletedMissions.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports